import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Guards routes that must only be reachable by `role === 'superuser'`
 * (tenant CRUD, global ops — see App.js nested routes under `path="superuser"`).
 */
export default function SuperuserRoute() {
  const { loading, isSuperuser } = useAuth();
  if (loading) {
    return (
      <div className="app-loading">
        <p>Loading…</p>
      </div>
    );
  }
  if (!isSuperuser) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
